import { useMethodsNative } from '@huse/methods';
const reducers = {
    on() {
        return true;
    },
    off() {
        return false;
    },
    toggle(value) {
        return !value;
    },
};
export function useBoolean(initialValue = false) {
    return useMethodsNative(reducers, initialValue);
}
export function useSwitch(initialValue = false) {
    const [value, { on, off, toggle }] = useBoolean(initialValue);
    return [value, on, off, toggle];
}
export function useToggle(initialValue = false) {
    const [value, { toggle }] = useBoolean(initialValue);
    return [value, toggle];
}
//# sourceMappingURL=index.js.map